<template>
  <footer class="footer_wrap" :class="{'footer_bottom_aboutus': pageType === 'aboutus' || pageType === 'production'}">
    <div class="footer_container">
      <div class="footer_top">
        <div class="footer_top_t">
          <img v-if="pageType === 'aboutus' || pageType === 'production'" class="footer_top_logo" src="@/assets/img/home/small_logo_other.png">
          <img v-else class="footer_top_logo" src="@/assets/img/home/small_logo.png">
          <img class="footer_top_arrow" src="@/assets/img/home/right_arrow.png">
          <span class="footer_top_title">{{ displayTitle }}</span>
        </div>
        <div class="footer_top_b">
          <span
            v-for="(item, index) in menuItems"
            :key="index"
            @click="changeCurrentPage(item.index)"
          >
            {{ item.label }}
          </span>
        </div>
      </div>
      <!-- 底部版权信息 -->
      <div class="footer_bottom">
        <div class="footer_legal">
          <p>customerservice@carbonneutrality-group.com</p>
          <p><a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">沪公网安备31010102008019</a> 丨 ‍<a href="https://beian.miit.gov.cn" target="_blank">苏ICP备2026061185号-1</a></p>
          <p>©2026中碳普惠云科技有限公司版权所有</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { menuItems, changePage } from '../navbar/shared'
export default {
  name: 'Footer',
  data() {
    return {
      menuItems,
      displayTitle: '首页'
    }
  },
  props: {
    pageType: {
      type: String,
      default: 'home'
    }
  },
  mounted() {
    this.updateDisplayTitle()
  },
  watch: {
    '$route.path': {
      handler: function() {
        this.updateDisplayTitle()
      },
      immediate: true
    }
  },
  computed: {
    currentPageTitle() {
      const currentPath = this.$route.path
      const matchedItem = this.menuItems.find(item => currentPath.includes(item.path.replace('/', '')))
      return matchedItem ? matchedItem.label : '首页'
    }
  },
  methods: {
    updateDisplayTitle() {
      const currentPath = this.$route.path
      // 精确匹配路由路径
      const matchedItem = this.menuItems.find(item => 
        currentPath === item.path || 
        currentPath === '/' + item.path ||
        currentPath.includes(item.path)
      )
      this.displayTitle = matchedItem ? matchedItem.label : '首页'
    },
    changeCurrentPage(index) {
      const item = this.menuItems.find(item => item.index === index)
      if (item) {
        this.displayTitle = item.label
      }
      changePage(index, this.$router)
    }
  }
}
</script>

<style lang="scss" scoped>
.footer_wrap {
  width: 100%;
  // height: calc(100vh * 290 / 1080);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  .footer_container{
    width: 100%;
    height: calc(100vh * 300 / 1080);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .footer_top{
      width: calc(100vw * 1000 / 1920);
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-bottom: 1px solid rgba(127, 127, 127, 1);

      .footer_top_t{
        display: flex;
        height: 30px;
        align-items: center;

        .footer_top_logo{
          width: 26px;
          height: 30px;
        }

        .footer_top_arrow{
          width: 10px;
          height: 20px;
          margin: 0 28px 0 32px;
        }

        .footer_top_title{
          font-weight: 400;
          font-size: 18px;
          color: rgba(64, 64, 64, 1);
        }
      }

      .footer_top_b{
        width: 100%;
        display: flex;
        height: 27px;
        align-items: center;
        justify-content: space-between;
        margin-top: 56px;
        font-weight: 700;
        font-size: 24px;
        color: rgba(0, 0, 0, 1);
        cursor: pointer;
      }
    }

    .footer_bottom{
      width: calc(100vw * 1000 / 1920);
      height: 100%;
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border-top: 1px solid rgba(191, 191, 191, 1);
      color: rgba(64, 64, 64, 1);

      .footer_legal{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      p{
        line-height: 150%;
      }

      a{
        color: rgba(64, 64, 64, 1);
        text-decoration: none;
        font-size: 16px;
      }
    }
  }
}

.footer_bottom_aboutus{
  background: rgba(0, 0, 0, 1);
  color: rgba(255, 255, 255, 1);

  .footer_top_title{
    color: rgba(255, 255, 255, 1)!important;
  }

  .footer_top_b{
    color: rgba(255, 255, 255, 1)!important;
  }

  .footer_bottom{
    color: rgba(255, 255, 255, 1)!important;

    a{
      color: rgba(255, 255, 255, 1)!important;
    }
  }
}
</style>